module.exports = __webpack_public_path__ + "img/gsndc2760_2.7a7e12c3.svg";